import { UIText1 } from '@cian/ui-kit';
import styles from './TooltipContent.css';
import { FC } from 'react';
import { NBSP } from 'shared/constants/symbols';
import { INearbyHousesInfo } from 'shared/types/marketTrends';

interface ITooltipContentProps {
  housesInfo: INearbyHousesInfo[];
}

export const TooltipContent: FC<ITooltipContentProps> = ({ housesInfo }) => {
  return (
    <div className={styles['content']}>
      <div className={styles['head']}>
        <UIText1>
          Это дома, расположенные в{NBSP}радиусе до{NBSP}2 километров и{NBSP}похожие друг на{NBSP}друга:
        </UIText1>
      </div>
      {housesInfo.map(item => (
        <div key={`${item.value}${item.title}`} className={styles['item']}>
          <UIText1 color="gray60_100">{item.title}</UIText1>
          <div className={styles['child']}>
            <UIText1>{item.value}</UIText1>
          </div>
        </div>
      ))}
    </div>
  );
};
